import { Language } from './language';

/** Learner position. */
export class LearnerPosition {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;

    /** @type {Language} */
    this.language = data.language;
  }
}
